/**
 * Latency marks for the §3.3 budgets: open → first paint, keystroke → each
 * provider's group painted. Uses the User Timing API (`palette:open`,
 * `palette:query`, `palette:paint:<provider>`) and keeps the last 5,000 samples
 * in a ring the e2e scale run reads (`window.__paletteMetrics`). Never
 * carries the query text.
 */
const MAX = 5000;
const samples = [];
const starts = new Map(); // key -> start time (performance.now() timebase)

const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

function push(sample) {
  samples.push(sample);
  if (samples.length > MAX) samples.shift();
  if (typeof window !== 'undefined') window.__paletteMetrics = samples;
}

/** `at` = the input event's `timeStamp` (same timebase as performance.now()). */
export function markStart(kind, key, at = now()) {
  starts.set(`${kind}:${key}`, at);
  try {
    performance.mark(`palette:${kind}`, { startTime: at });
  } catch {
    /* old engines: no options bag */
  }
}

/** Called after the frame that shows `what` (rAF after commit). */
export function markPainted(kind, key, what) {
  const start = starts.get(`${kind}:${key}`);
  if (start == null) return null;
  const ms = now() - start;
  push({ kind, what, ms: Math.round(ms * 10) / 10 });
  try {
    performance.measure(`palette:paint:${what}`, { start, end: now() });
  } catch {
    /* ignore */
  }
  return ms;
}

export function endStart(kind, key) {
  starts.delete(`${kind}:${key}`);
}

export function getSamples() {
  return samples.slice();
}
